export const Footer = () => (
    <footer data-testid="site-footer" className="bg-ink text-bone">
        <div className="mx-auto max-w-7xl px-6 py-24 md:px-12">
            <div className="flex flex-col justify-between gap-16 md:flex-row">
                <div>
                    <p className="font-serif text-5xl font-medium tracking-tight md:text-7xl" data-testid="footer-logo">
                        Policy<span className="italic text-clay">One</span><span className="text-clay">.</span>
                    </p>
                    <p className="mt-6 max-w-sm text-sm leading-relaxed text-bone/70">
                        Coimbatore's independent insurance advisory. Every insurer, one advisor, zero confusion — since 2008.
                    </p>
                </div>
                <div className="grid grid-cols-2 gap-16">
                    <div>
                        <p className="mb-6 font-mono text-[11px] uppercase tracking-[0.2em] text-bone/50">Explore</p>
                        <ul className="space-y-4">
                            {[["Coverages", "#coverages"], ["Why PolicyOne", "#manifesto"], ["Insurers", "#insurers"], ["FAQ", "#faq"], ["Get a Quote", "#quote"]].map(([label, href]) => (
                                <li key={href}>
                                    <a href={href} className="text-sm text-bone/80 transition-colors duration-300 hover:text-clay">{label}</a>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div>
                        <p className="mb-6 font-mono text-[11px] uppercase tracking-[0.2em] text-bone/50">Visit us</p>
                        <p className="text-sm leading-relaxed text-bone/80">
                            1/2B Raviram Complex, Madukkarai Road,<br />
                            Opp. Old Dinamalar Office, Sundarapuram,<br />
                            Coimbatore, Tamil Nadu 641 021<br />
                            <a href="tel:+919994158837" className="mt-3 block transition-colors duration-300 hover:text-clay">+91 99941 58837</a>
                            <a href="tel:+919788800043" className="block transition-colors duration-300 hover:text-clay">+91 97888 00043</a>
                            <a href="mailto:care@policy1.co.in" className="mt-3 block transition-colors duration-300 hover:text-clay">care@policy1.co.in</a>
                            <a href="https://www.policy1.co.in" target="_blank" rel="noopener noreferrer" className="block transition-colors duration-300 hover:text-clay">www.policy1.co.in</a>
                        </p>
                    </div>
                </div>
            </div>
            <div className="mt-20 flex flex-col justify-between gap-4 border-t border-bone/15 pt-8 md:flex-row">
                <p className="font-mono text-[11px] uppercase tracking-[0.15em] text-bone/50" data-testid="footer-copyright">
                    © {new Date().getFullYear()} PolicyOne Insurance Advisory · Coimbatore
                </p>
                <p className="max-w-xl font-mono text-[10px] uppercase leading-relaxed tracking-[0.1em] text-bone/40">
                    Insurance is the subject matter of solicitation. IRDAI registration details available at our office.
                </p>
            </div>
        </div>
    </footer>
);
